import React from 'react';
import PropType from 'prop-types';

import PageTitleNew from 'components/ui/PageTitleNew';

import Table from './Table';

export default function Index({ enterpriseId }) {
  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="Programs" />

      <div className="ibox-content mt20">
        <Table enterpriseId={enterpriseId} />
      </div>
    </div>
  );
}

Index.propTypes = {
  enterpriseId: PropType.number,
};

Index.defaultProps = {
  enterpriseId: null,
};
